// COMPLETE Keyboard Layouts for ALL Languages
// Based on standard keyboard layouts for each language with ALL special characters

export const keyboardLayouts = {
  // English - Standard QWERTY
  en: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
      ["z", "x", "c", "v", "b", "n", "m"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
      ["Z", "X", "C", "V", "B", "N", "M"]
    ]
  },

  // Hindi - Devanagari Script (InScript layout)
  hi: {
    lowercase: [
      ["ौ", "ै", "ा", "ी", "ू", "ब", "ह", "ग", "द", "ज"],
      ["ो", "े", "्", "ि", "ु", "प", "र", "क", "त", "च"],
      ["ॉ", "ं", "म", "न", "व", "ल", "स", "य", "ष", "श"],
      ["क्ष", "त्र", "ज्ञ", "ड", "ढ", "ण", "थ", "ध", "ख", "घ"]
    ],
    uppercase: [
      ["औ", "ऐ", "आ", "ई", "ऊ", "भ", "ङ", "घ", "ध", "झ"],
      ["ओ", "ए", "अ", "इ", "उ", "फ", "ऋ", "ख", "थ", "छ"],
      ["ऑ", "ँ", "ण", "ञ", "ऌ", "ळ", "श्र", "य़", "ष", "श"],
      ["क्ष", "त्र", "ज्ञ", "ड़", "ढ़", "ऩ", "ऱ", "ऴ", "ऻ", "ऽ"]
    ]
  },

  // Arabic - Standard Arabic Keyboard
  ar: {
    lowercase: [
      ["ض", "ص", "ث", "ق", "ف", "غ", "ع", "ه", "خ", "ح"],
      ["ج", "د", "ش", "س", "ي", "ب", "ل", "ا", "ت", "ن"],
      ["م", "ك", "ط", "ذ", "ز", "ر", "و", "ة", "ى", "ظ"]
    ],
    uppercase: [
      ["َ", "ً", "ُ", "ٌ", "ِ", "ٍ", "ّ", "ْ", "ء", "آ"],
      ["أ", "إ", "ؤ", "ئ", "لا", "لإ", "لأ", "لآ", "ـ", "ٰ"],
      ["ٓ", "ٔ", "ٕ", "ٖ", "ٗ", "٘", "ٙ", "ٚ", "ٛ", "ٜ"]
    ]
  },

  // Spanish - Complete with all accents and special characters
  es: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ñ"],
      ["z", "x", "c", "v", "b", "n", "m", "á", "é", "í"],
      ["ó", "ú", "ü", "¿", "¡", "«", "»"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ñ"],
      ["Z", "X", "C", "V", "B", "N", "M", "Á", "É", "Í"],
      ["Ó", "Ú", "Ü", "¿", "¡", "«", "»"]
    ]
  },

  // French - AZERTY layout with ALL accents
  fr: {
    lowercase: [
      ["a", "z", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["q", "s", "d", "f", "g", "h", "j", "k", "l", "m"],
      ["w", "x", "c", "v", "b", "n", "ù", "é", "è", "ç"],
      ["à", "â", "ê", "î", "ô", "û", "ë", "ï", "ü", "ÿ"],
      ["æ", "œ", "€", "£", "¥", "§", "°", "µ", "¤"]
    ],
    uppercase: [
      ["A", "Z", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["Q", "S", "D", "F", "G", "H", "J", "K", "L", "M"],
      ["W", "X", "C", "V", "B", "N", "Ù", "É", "È", "Ç"],
      ["À", "Â", "Ê", "Î", "Ô", "Û", "Ë", "Ï", "Ü", "Ÿ"],
      ["Æ", "Œ", "€", "£", "¥", "§", "°", "µ", "¤"]
    ]
  },

  // German - QWERTZ layout with umlauts
  de: {
    lowercase: [
      ["q", "w", "e", "r", "t", "z", "u", "i", "o", "p", "ü"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ö", "ä"],
      ["y", "x", "c", "v", "b", "n", "m", "ß", "€"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Z", "U", "I", "O", "P", "Ü"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ö", "Ä"],
      ["Y", "X", "C", "V", "B", "N", "M", "ẞ", "€"]
    ]
  },

  // Russian - ЙЦУКЕН layout
  ru: {
    lowercase: [
      ["й", "ц", "у", "к", "е", "н", "г", "ш", "щ", "з", "х"],
      ["ф", "ы", "в", "а", "п", "р", "о", "л", "д", "ж", "э"],
      ["я", "ч", "с", "м", "и", "т", "ь", "б", "ю", "ъ", "ё"]
    ],
    uppercase: [
      ["Й", "Ц", "У", "К", "Е", "Н", "Г", "Ш", "Щ", "З", "Х"],
      ["Ф", "Ы", "В", "А", "П", "Р", "О", "Л", "Д", "Ж", "Э"],
      ["Я", "Ч", "С", "М", "И", "Т", "Ь", "Б", "Ю", "Ъ", "Ё"]
    ]
  },

  // Japanese - Hiragana/Katakana
  ja: {
    lowercase: [
      ["あ", "い", "う", "え", "お", "か", "き", "く", "け", "こ"],
      ["さ", "し", "す", "せ", "そ", "た", "ち", "つ", "て", "と"],
      ["な", "に", "ぬ", "ね", "の", "は", "ひ", "ふ", "へ", "ほ"],
      ["ま", "み", "む", "め", "も", "や", "ゆ", "よ", "ら", "り"],
      ["る", "れ", "ろ", "わ", "を", "ん", "が", "ぎ", "ぐ", "げ"]
    ],
    uppercase: [
      ["ア", "イ", "ウ", "エ", "オ", "カ", "キ", "ク", "ケ", "コ"],
      ["サ", "シ", "ス", "セ", "ソ", "タ", "チ", "ツ", "テ", "ト"],
      ["ナ", "ニ", "ヌ", "ネ", "ノ", "ハ", "ヒ", "フ", "ヘ", "ホ"],
      ["マ", "ミ", "ム", "メ", "モ", "ヤ", "ユ", "ヨ", "ラ", "リ"],
      ["ル", "レ", "ロ", "ワ", "ヲ", "ン", "ガ", "ギ", "グ", "ゲ"]
    ]
  },

  // Chinese - Pinyin (uses English QWERTY for input)
  zh: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
      ["z", "x", "c", "v", "b", "n", "m"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
      ["Z", "X", "C", "V", "B", "N", "M"]
    ]
  },

  // Korean - 2-Set (Dubeolsik) layout
  ko: {
    lowercase: [
      ["ㅂ", "ㅈ", "ㄷ", "ㄱ", "ㅅ", "ㅛ", "ㅕ", "ㅑ", "ㅐ", "ㅔ"],
      ["ㅁ", "ㄴ", "ㅇ", "ㄹ", "ㅎ", "ㅗ", "ㅓ", "ㅏ", "ㅣ"],
      ["ㅋ", "ㅌ", "ㅊ", "ㅍ", "ㅠ", "ㅜ", "ㅡ"]
    ],
    uppercase: [
      ["ㅃ", "ㅉ", "ㄸ", "ㄲ", "ㅆ", "ㅛ", "ㅕ", "ㅑ", "ㅒ", "ㅖ"],
      ["ㅁ", "ㄴ", "ㅇ", "ㄹ", "ㅎ", "ㅗ", "ㅓ", "ㅏ", "ㅣ"],
      ["ㅋ", "ㅌ", "ㅊ", "ㅍ", "ㅠ", "ㅜ", "ㅡ"]
    ]
  },

  // Portuguese - Complete with all accents and tildes
  pt: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ç"],
      ["z", "x", "c", "v", "b", "n", "m", "á", "é", "í"],
      ["ó", "ú", "â", "ê", "ô", "à", "ã", "õ", "ü"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ç"],
      ["Z", "X", "C", "V", "B", "N", "M", "Á", "É", "Í"],
      ["Ó", "Ú", "Â", "Ê", "Ô", "À", "Ã", "Õ", "Ü"]
    ]
  },

  // Italian - Complete with all accents
  it: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ò"],
      ["z", "x", "c", "v", "b", "n", "m", "à", "è", "é"],
      ["ì", "ù", "ó", "í", "ú", "€"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ò"],
      ["Z", "X", "C", "V", "B", "N", "M", "À", "È", "É"],
      ["Ì", "Ù", "Ó", "Í", "Ú", "€"]
    ]
  },

  // Dutch - Standard QWERTY (same as English)
  nl: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
      ["z", "x", "c", "v", "b", "n", "m", "é", "ë", "ï"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
      ["Z", "X", "C", "V", "B", "N", "M", "É", "Ë", "Ï"]
    ]
  },

  // Swedish - QWERTY with Å, Ä, Ö
  sv: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "å"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ö", "ä"],
      ["z", "x", "c", "v", "b", "n", "m"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "Å"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ö", "Ä"],
      ["Z", "X", "C", "V", "B", "N", "M"]
    ]
  },

  // Danish - QWERTY with Æ, Ø, Å
  da: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "å"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l", "æ", "ø"],
      ["z", "x", "c", "v", "b", "n", "m"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "Å"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Æ", "Ø"],
      ["Z", "X", "C", "V", "B", "N", "M"]
    ]
  },

  // Norwegian - QWERTY with Æ, Ø, Å
  no: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "å"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ø", "æ"],
      ["z", "x", "c", "v", "b", "n", "m"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "Å"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ø", "Æ"],
      ["Z", "X", "C", "V", "B", "N", "M"]
    ]
  },

  // Finnish - QWERTY with Å, Ä, Ö
  fi: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p", "å"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ö", "ä"],
      ["z", "x", "c", "v", "b", "n", "m"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "Å"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ö", "Ä"],
      ["Z", "X", "C", "V", "B", "N", "M"]
    ]
  },

  // Polish - QWERTY with Polish diacritics
  pl: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ł"],
      ["z", "x", "c", "v", "b", "n", "m", "ą", "ć", "ę"],
      ["ń", "ó", "ś", "ź", "ż"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ł"],
      ["Z", "X", "C", "V", "B", "N", "M", "Ą", "Ć", "Ę"],
      ["Ń", "Ó", "Ś", "Ź", "Ż"]
    ]
  },

  // Turkish - F-keyboard layout with Turkish characters
  tr: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "ı", "o", "p", "ğ"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ş", "i"],
      ["z", "x", "c", "v", "b", "n", "m", "ö", "ç", "ü"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "Ğ"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ş", "İ"],
      ["Z", "X", "C", "V", "B", "N", "M", "Ö", "Ç", "Ü"]
    ]
  },

  // Thai - Kedmanee layout
  th: {
    lowercase: [
      ["ๅ", "ภ", "ถ", "ุ", "ึ", "ค", "ต", "จ", "ข", "ช"],
      ["ไ", "ำ", "พ", "ะ", "ั", "ี", "ร", "น", "ย", "บ"],
      ["ล", "ฟ", "ห", "ก", "ด", "เ", "้", "่", "า", "ส"],
      ["ว", "ง", "ผ", "ป", "แ", "อ", "ิ", "ื", "ท", "ม"]
    ],
    uppercase: [
      ["+", "ฎ", "ฑ", "ธ", "ํ", "๊", "ณ", "ฯ", "ญ", "ฐ"],
      ["๐", "\"", "ฤ", "ฆ", "ู", "๋", "ษ", "ศ", "ซ", "ฌ"],
      ["ฦ", "ฝ", "ฮ", "ข", "ฏ", "โ", "ฌ", "็", "๋", "ฃ"],
      ["ฅ", "ฉ", "ฐ", "ภ", "ฒ", "ฮ", "ฺ", "์", "?", "ฦ"]
    ]
  },

  // Vietnamese - QWERTY with Vietnamese diacritics
  vi: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
      ["z", "x", "c", "v", "b", "n", "m", "ă", "â", "đ"],
      ["ê", "ô", "ơ", "ư", "á", "à", "ả", "ã", "ạ", "ắ"],
      ["ằ", "ẳ", "ẵ", "ặ", "ấ", "ầ", "ẩ", "ẫ", "ậ", "é"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
      ["Z", "X", "C", "V", "B", "N", "M", "Ă", "Â", "Đ"],
      ["Ê", "Ô", "Ơ", "Ư", "Á", "À", "Ả", "Ã", "Ạ", "Ắ"],
      ["Ằ", "Ẳ", "Ẵ", "Ặ", "Ấ", "Ầ", "Ẩ", "Ẫ", "Ậ", "É"]
    ]
  },

  // Indonesian - Standard QWERTY (same as English)
  id: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
      ["z", "x", "c", "v", "b", "n", "m"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
      ["Z", "X", "C", "V", "B", "N", "M"]
    ]
  },

  // Malay - Standard QWERTY (same as English)
  ms: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l"],
      ["z", "x", "c", "v", "b", "n", "m"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L"],
      ["Z", "X", "C", "V", "B", "N", "M"]
    ]
  },

  // Filipino/Tagalog - Standard QWERTY with Ñ
  tl: {
    lowercase: [
      ["q", "w", "e", "r", "t", "y", "u", "i", "o", "p"],
      ["a", "s", "d", "f", "g", "h", "j", "k", "l", "ñ"],
      ["z", "x", "c", "v", "b", "n", "m"]
    ],
    uppercase: [
      ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
      ["A", "S", "D", "F", "G", "H", "J", "K", "L", "Ñ"],
      ["Z", "X", "C", "V", "B", "N", "M"]
    ]
  },

  // Hebrew - Standard Hebrew keyboard
  he: {
    lowercase: [
      ["ק", "ר", "א", "ט", "ו", "ן", "ם", "פ"],
      ["ש", "ד", "ג", "כ", "ע", "י", "ח", "ל", "ך", "ף"],
      ["ז", "ס", "ב", "ה", "נ", "מ", "צ", "ת", "ץ"]
    ],
    uppercase: [
      ["ק", "ר", "א", "ט", "ו", "ן", "ם", "פ"],
      ["ש", "ד", "ג", "כ", "ע", "י", "ח", "ל", "ך", "ף"],
      ["ז", "ס", "ב", "ה", "נ", "מ", "צ", "ת", "ץ"]
    ]
  },

  // Persian/Farsi - Standard Persian keyboard
  fa: {
    lowercase: [
      ["ض", "ص", "ث", "ق", "ف", "غ", "ع", "ه", "خ", "ح"],
      ["ج", "چ", "ش", "س", "ی", "ب", "ل", "ا", "ت", "ن"],
      ["م", "ک", "گ", "پ", "ظ", "ط", "ز", "ر", "ذ", "د"],
      ["ژ", "و", "ؤ", "ئ", "ي", "ة", "ى", "آ"]
    ],
    uppercase: [
      ["ْ", "ٌ", "ٍ", "ً", "ُ", "ِ", "َ", "ّ", "ٓ", "ٰ"],
      ["ج", "چ", "ش", "س", "ی", "ب", "ل", "ا", "ت", "ن"],
      ["م", "ک", "گ", "پ", "ظ", "ط", "ز", "ر", "ذ", "د"],
      ["ژ", "و", "ؤ", "ئ", "ي", "ة", "ى", "آ"]
    ]
  },

  // Urdu - Standard Urdu keyboard
  ur: {
    lowercase: [
      ["ط", "ص", "ھ", "د", "ٹ", "پ", "ت", "ب", "ج", "ح"],
      ["م", "و", "ر", "ن", "ل", "ہ", "ا", "ک", "ی", "ے"],
      ["ق", "ف", "ے", "س", "ش", "غ", "ع", "خ", "ض", "ذ"],
      ["ژ", "ز", "ڑ", "ڈ", "چ", "ث", "ء", "آ"]
    ],
    uppercase: [
      ["ٓ", "ً", "ٌ", "ٍ", "َ", "ُ", "ِ", "ّ", "ْ", "ٰ"],
      ["م", "و", "ر", "ن", "ل", "ہ", "ا", "ک", "ی", "ے"],
      ["ق", "ف", "ے", "س", "ش", "غ", "ع", "خ", "ض", "ذ"],
      ["ژ", "ز", "ڑ", "ڈ", "چ", "ث", "ء", "آ"]
    ]
  }
};
